var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon awesome-camera",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.59,
    height: 8.391,
    viewBox: "0 0 9.59 8.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-camera",
    d: "M9.59 4.348v5.394a.9.9 0 0 1-.9.9H.9a.9.9 0 0 1-.9-.9V4.348a.9.9 0 0 1 .9-.9h1.647l.23-.616a.9.9 0 0 1 .841-.583h2.351a.9.9 0 0 1 .841.583l.232.616h1.649a.9.9 0 0 1 .899.9zm-2.547 2.7A2.248 2.248 0 1 0 4.8 9.293a2.249 2.249 0 0 0 2.243-2.248zm-.6 0A1.648 1.648 0 1 1 4.8 5.4a1.651 1.651 0 0 1 1.643 1.645z",
    transform: "translate(0 -2.25)",
    style: {
      fill: "#fafbfd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.1bc75da02731f260e4924c609a402da1.svg";
export { ForwardRef as ReactComponent };